var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.tz=require("ttag");module.exports=$CLJS.tz;